var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass:
        "group shadow mb-6 cursor-pointer text-grey-darkest leading-normal",
      attrs: {
        to: {
          name: "partner-timeslot.show",
          query: {
            doctorId: _vm.appointment.doctorId,
            dateTime: _vm.appointment.dateTime,
            medicalPractice: _vm.appointment.medicalPractice,
            latitude: _vm.appointment.officeLatitude,
            longitude: _vm.appointment.officeLongitude
          }
        },
        tag: "div"
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
        [
          _c("partner-avatar", {
            staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
            attrs: { "external-url": _vm.appointment.doctorAvatar }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "ml-4" }, [
            _c("div", { staticClass: "flex md:mb-1" }, [
              _c(
                "span",
                { staticClass: "icon mr-2 md:text-lg text-grey-darkest" },
                [_c("i", { staticClass: "mdi mdi-calendar-check" })]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "text-grey-darkest font-semibold text-sm md:text-base"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("momentFormatTimestamp")(
                        _vm.appointment.dateTime,
                        _vm.$t("date_selector_format") +
                          " [" +
                          _vm.$t("at") +
                          "] " +
                          _vm.$t("time_format")
                      )
                    )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex md:mb-1" }, [
              _c("span", { staticClass: "icon mr-2 text-lg text-red-light" }, [
                _c("i", { staticClass: "mdi mdi-map-marker" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-sm md:text-base" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.appointment.officeZipCode) +
                    " " +
                    _vm._s(_vm.appointment.officeLocality)
                ),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.appointment.officeStreetName) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _c("span", { staticClass: "icon mr-2 text-lg text-blue-light" }, [
                _c("i", { staticClass: "mdi mdi-account" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-sm md:text-base" }, [
                _vm._v(
                  _vm._s(
                    _vm.appointment.doctorFirstName +
                      " " +
                      _vm.appointment.doctorLastName
                  )
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "transition flex rounded-b bg-teal group-hover:bg-teal-dark text-white py-1 justify-center"
        },
        [
          _c("span", {
            staticClass: "uppercase tracking-wide font-semibold text-sm",
            domProps: { textContent: _vm._s(_vm.$t("Appointment_confirmed")) }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88748b7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88748b7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/PartnerAppointmentListItem.vue
// module id = 592
// module chunks = 1